// extracted by mini-css-extract-plugin
module.exports = {"turnSection":"TurnSection_turnSection__hYuQp","content":"TurnSection_content__17qSx","background":"TurnSection_background__28xgD"};